<template>
  <pf-flex justify-content="space-between" class="pf-v6-u-mb-md">
    <pf-title h="3">{{ $t('Storico Movimenti') }}</pf-title>

    <div v-if="movements.length > 0">
      <x-input
        type="search"
        v-model="filter"
        :placeholder="$t('Filtra')"
      />
    </div>
  </pf-flex>

  <template v-if="movements.length > 0">
    <pf-table v-if="filtered.length > 0" compact striped>
      <pf-thead>
        <pf-tr>
          <pf-th>{{ $t('Descrizione') }}</pf-th>
          <pf-th class="pf-v6-u-text-align-end-on-md">
            <sort-link v-model="sort" v-model:reverse="reverseSort" field="amount">
              {{ $t('Valore') }}
            </sort-link>
          </pf-th>
          <pf-th class="pf-v6-u-text-align-end-on-md">
            <sort-link v-model="sort" v-model:reverse="reverseSort" field="data">
              {{ $t('Data') }}
            </sort-link>
          </pf-th>
        </pf-tr>
      </pf-thead>
      <pf-tbody>
        <pf-tr
          v-for="provvigione in paged"
          :key="provvigione.id"
        >
          <pf-td>{{ provvigione.dettagli }}</pf-td>
          <pf-td
            class="pf-v6-u-text-align-end-on-md"
            :class="{ 'pf-v6-u-text-color-status-success': provvigione.amount > 0, 'pf-v6-u-text-color-status-danger': provvigione.amount < 0 }"
          >
            {{ $currency(provvigione.amount, currency) }}
          </pf-td>
          <pf-td class="pf-v6-u-text-align-end-on-md">{{ $date(provvigione.data) }} <span class="pf-v6-u-text-color-status-warning">{{ expiringLabel(provvigione.data) }}</span></pf-td>
        </pf-tr>
      </pf-tbody>
    </pf-table>
    <pf-empty-state v-else variant="xs">
      <pf-empty-state-header :title="$t('Nessun movimento trovato con il filtro selezionato.')" />
    </pf-empty-state>
    <pf-pagination
      v-model:page="pageNum"
      v-model:per-page="itemsPerPage"
      :count="filtered.length"
    />
  </template>

  <pf-empty-state v-else variant="xs">
    <pf-empty-state-header :title="$t('Nessun movimento.')" />
  </pf-empty-state>
</template>

<style scoped>
.value-cell {
  text-align: right;
}
</style>

<script lang="ts" setup>
import { type Ref, ref, computed, watch } from 'vue';
import { by } from '@common/utils';
import { any } from '@common/utils';
import { $t as _t } from '@/i18n';
import SortLink from '../components/sort-link.vue';
import type { AccountMovement } from '@/resources';
import { parseDateTime } from "@common/date";
import { DateTime } from 'luxon';

const props = withDefaults(defineProps<{
  movements: AccountMovement[],
  currency: 'CHF' | 'EUR',
  expiringMonths?: number|null,
  titleH?: number,
}>(), {
  expiringMonths: 15,
});

const pageNum = ref(1);
const filter = ref('');
const itemsPerPage = ref(50);
const sort: Ref<'data'|'amount'> = ref('data');
const reverseSort = ref(true);

const filtered = computed(() => props.movements.filter(any(filter.value)).sort(by(sort.value, reverseSort.value)));

const paged = computed(() =>  {
  const page = Math.min(pageNum.value, Math.ceil(filtered.value.length / itemsPerPage.value));
  return filtered.value.slice((page - 1) * itemsPerPage.value, page * itemsPerPage.value);
});

watch(filter, () => {
  resetPage(1);
});

function resetPage(value: number) {
  pageNum.value = value;
}

function expiringLabel(strdate: string) {
  const now = DateTime.local();
  const date = parseDateTime(strdate);
  const diff = date.diff(now, ['months']).months;
  const expiring = date.plus({months: 15}).toFormat('dd/MM/yyyy');


  return diff < -12 ? _t(`In scadenza il {0}`, [expiring]) : "";
}

defineExpose({
  resetPage,
});
</script>
